import styled from 'styled-components';
import { BasketFeesDetailsStyled } from '../../BasketFeesDetailsStyled';
import { rem } from 'polished';

export const BasketFeesDetailsOV = styled(BasketFeesDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }
    
    .title {
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }
    
    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }
    
    .carteGriseInput {
        .postalCode {
            background: ${({ theme }) => theme.colors.grey27};
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            
            &_input {
                button {
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                }
            }
        }
    }
`;
